
import service from '../request/index'

// 我上传的资源
export function getMyUpload (data) {
  return service({
    url: '/es/resource/lib/myself/upload',
    method: 'POST',
    data
  })
}


// 设为公开/不公开
export function setOpen (data) {
  return service({
    url: '/es/resource/lib/open',
    method: 'GET',
    params: data
  })
}




// 删除资源
export function deleteMyUpload (data) {
  return service({
    url: '/es/resource/lib/delete',
    method: 'DELETE',
    data
  })
}


// 我的下载
export function getMyDownload (data) {
  return service({
    url: '/es/resource/download/myself',
    method: 'POST',
    data
  })
}


// 移除 我的下载
export function deleteMyDownload (data) {
  return service({
    url: '/es/resource/download/delete',
    method: 'DELETE',
    data
  })
}

// 我的收藏
export function getMyCollect (data) {
  return service({
    url: '/es/resource/collect/myself',
    method: 'POST',
    data
  })
}


// 收藏/取消收藏
export function cancelCollect (data) {
  return service({
    url: '/es/resource/collect/update/data',
    method: 'GET',
    params: data
  })
}

// 浏览记录列表

export function getHistory (data) {
  return service({
    url: '/es/resource/view/history',
    method: 'GET',
    params: data
  })
}


// 删除一条浏览数据
export function deleteHistory (data) {
  return service({
    url: '/es/resource/view/delete',
    method: 'DELETE',
    data: data
  })
}



// 删除本人全部浏览数据
export function deleteAllHistory () {
  return service({
    url: '/es/resource/view/deleteAll',
    method: 'DELETE',
  })
}


// 我的购买
export function getMyBuyRecord (data) {
  return service({
    url: '/es/resource/my/buy/record',
    method: 'POST',
    data
  })
}
// 我的资源统计
export function getMyStatistics (data) {
  return service({
    url: '/es/resource/my/resource/statistics',
    method: 'GET',
    params: data
  })
}
// 收入支出
export function getMyRevenue (data) {
  return service({
    url: '/es/resource/my/revenue/expenditure',
    method: 'GET',
    params: data
  })
}

// 我的认证信息
export function getVerify () {
  return service({
    url: '/es/resource/my/verifyAccount/info',
    method: 'GET',
  })
}




// 上传认证信息  版本1
// export function uploadVerify (data) {
//   return service({
//     url: '/es/resource/my/verify/upload',
//     method: 'POST',
//     data
//   })
// }

// 我的收入
export function getRevenue (data) {
  return service({
    url: '/es/resource/my/revenue/record',
    method: 'POST',
    data
  })
}


// 我的支出
export function getExpenditure (data) {
  return service({
    url: '/es/resource/my/expenditure/record',
    method: 'POST',
    data
  })
}

// 账户设置
export function setAccount (data) {
  return service({
    url: '/es/resource/my/account',
    method: 'POST',
    data
  })
}

// 获取我的账户设置
export function getAccount (data) {
  return service({
    url: '/es/resource/my/account/info',
    method: 'get',
  })
}

//微信登陆
// export function wechat (){
//   return service({
//     url: '/es/resource/my/account/info',
//     method: 'get',
//   })
// }


// 个人空间头部的 我的统计
export function getMyTopStatistics (data) {
  return service({
    url: '/es/resource/my/statistics',
    method: 'get',
  })
}

// 上传认证信息

export function verifyAccount (data) {
  return service({
    url: '/es/resource/my/verifyAccount/upload',
    method: 'post',
    data
  })
}


// 工单新增

export function woInsert (data) {
  return service({
    url: '/es//wo/insert',
    method: 'post',
    data
  })
}

// 工单详情
export function woInfo (data) {
  return service({
    url: '/es//wo/info',
    method: 'get',
    params:data
  })
}


// 我的精品课程
export function getMyCourse (data) {
  return service({
    url: '/api/course/resource/my',
    method: 'post',
    data:data
  })
}